import { render, staticRenderFns } from "./column-editor-dialog.vue?vue&type=template&id=1a07cfd9&"
import script from "./column-editor-dialog.vue?vue&type=script&lang=js&"
export * from "./column-editor-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports